import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { courseAPI, enrollmentAPI, certificateAPI } from '../../services/api';
import { LoadingSpinner } from '../../components/UI';
import { useAuth } from '../../context/AuthContext';

const TrainerDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [courses, students, certs] = await Promise.all([
          courseAPI.myAsTrainer(),
          enrollmentAPI.trainerStudents(),
          certificateAPI.trainerIssued(),
        ]);
        setStats({
          courses: courses.data,
          students: students.data,
          certs: certs.data,
        });
      } catch (e) { console.error(e); }
    })();
  }, []);

  if (!stats) return <LoadingSpinner />;

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1 style={{ color: 'var(--green)' }}>Trainer Dashboard</h1>
          <p className="subtitle">Welcome back, {user?.name}</p>
        </div>
      </div>

      <div className="grid grid-3">
        <div className="stat-card">
          <div className="accent-bar"></div>
          <div className="label">My Courses</div>
          <div className="value">{stats.courses.length}</div>
        </div>
        <div className="stat-card">
          <div className="accent-bar" style={{ background: 'var(--accent)' }}></div>
          <div className="label">Active Students</div>
          <div className="value">{stats.students.length}</div>
        </div>
        <div className="stat-card">
          <div className="accent-bar" style={{ background: 'var(--success)' }}></div>
          <div className="label">Certificates Issued</div>
          <div className="value">{stats.certs.length}</div>
        </div>
      </div>

      <div className="mt-3">
        <h3 className="mb-2">My Courses</h3>
        {stats.courses.length === 0 ? (
          <div className="card text-center text-muted">No courses assigned. Contact admin.</div>
        ) : (
          <div className="grid grid-3">
            {stats.courses.map((c) => (
              <div key={c._id} className="course-card">
                <div className="thumb">{c.title.charAt(0)}</div>
                <div className="body">
                  <span className="category">{c.category}</span>
                  <h3>{c.title}</h3>
                  <p className="desc">{c.description}</p>
                  <div className="meta">
                    <span>{c.modules?.length || 0} modules</span>
                    <span>{stats.students.filter((s) => s.course?._id === c._id).length} students</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-3">
        <div className="flex justify-between items-center mb-2">
          <h3>Recent students</h3>
          <Link to="/trainer/students" className="btn btn-secondary btn-sm">View all</Link>
        </div>
        {stats.students.slice(0, 5).map((s) => (
          <div key={s._id} className="card mb-2 flex justify-between items-center">
            <div>
              <strong>{s.user?.name}</strong>
              <div className="text-muted" style={{ fontSize: '0.85rem' }}>{s.course?.title}</div>
            </div>
            <div style={{ minWidth: 150 }}>
              <div className="progress"><div className="progress-bar" style={{ width: `${s.progress}%` }}></div></div>
              <small className="text-muted">{s.progress}%</small>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrainerDashboard;
